/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import preview from 'ui/components/theme/preview.mixin';

const __vue_script__ = {
    name: 'WebPreview',

    mixins: [preview]
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"web-preview",attrs:{"viewBox":"0 0 672 420","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_941_26253)"}},[_c('rect',{attrs:{"width":"672","height":"420","rx":"8","fill":_vm.backgroundColor4 || '#FFFFFF'}}),_c('rect',{attrs:{"x":"90.25","y":"43.25","width":"75.5","height":"62.5","rx":"1.75","fill":_vm.isV3 ? _vm.brandColor : _vm.color9}}),_c('path',{attrs:{"d":"M90.25 67.25H165.75V104C165.75 104.966 164.966 105.75 164 105.75H92C91.0335 105.75 90.25 104.966 90.25 104V67.25Z","fill":_vm.backgroundColor3 || _vm.color9}}),_c('rect',{attrs:{"x":"96","y":"83","width":"40","height":"4.10526","rx":"2","fill":_vm.foregroundColor1 || _vm.color6}}),_c('rect',{attrs:{"x":"96","y":"91.2104","width":"40","height":"4.10526","rx":"2","fill":_vm.foregroundColor2 || _vm.color7}}),_c('path',{attrs:{"d":"M90.25 67.25H165.75V104C165.75 104.966 164.966 105.75 164 105.75H92C91.0335 105.75 90.25 104.966 90.25 104V67.25Z","stroke":_vm.backgroundColor2,"stroke-width":"0.5"}}),_c('circle',{attrs:{"cx":"109.5","cy":"66.5","r":"12.825","fill":_vm.brandColor,"stroke":_vm.color2,"stroke-width":"1.35"}}),_c('path',{attrs:{"d":"M102.323 70.7002H103.847V65.8328H103.931L107.454 70.7002H108.772V63.0906H107.248V67.9369H107.164L103.652 63.0906H102.323V70.7002ZM113.344 70.8953C115.243 70.8953 116.413 69.9408 116.413 68.4326V68.4273C116.413 67.2408 115.712 66.5975 114.104 66.2652L113.297 66.1018C112.4 65.9172 112.031 65.6219 112.031 65.1262V65.1209C112.031 64.5514 112.553 64.1928 113.339 64.1875C114.141 64.1875 114.668 64.5672 114.758 65.1104L114.768 65.1736H116.266L116.26 65.1051C116.16 63.8342 115.116 62.8955 113.339 62.8955C111.651 62.8955 110.439 63.8289 110.439 65.2422V65.2475C110.439 66.4023 111.119 67.1406 112.701 67.4623L113.502 67.6258C114.446 67.8209 114.821 68.1004 114.821 68.6014V68.6066C114.821 69.192 114.235 69.598 113.386 69.598C112.495 69.598 111.878 69.2131 111.82 68.6436L111.815 68.5908H110.28L110.286 68.6752C110.375 70.0252 111.525 70.8953 113.344 70.8953Z","fill":_vm.color2}}),_c('rect',{attrs:{"x":"90.25","y":"43.25","width":"75.5","height":"62.5","rx":"1.75","stroke":_vm.backgroundColor2 || '#E5E6E6',"stroke-width":"0.5"}}),_c('rect',{attrs:{"x":"90","y":"114","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"115","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"128","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"129","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"142","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"143","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"156","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"157","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"170","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"171","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"184","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"185","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"198","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"199","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"90","y":"212","width":"6","height":"6","rx":"2","fill":_vm.tintIcons ? _vm.color4 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"100","y":"213","width":"56","height":"4","rx":"2","fill":_vm.foregroundColor1 || '#000000'}}),_c('rect',{attrs:{"x":"182.5","y":"43.5","width":"40.4","height":"7","rx":"1.5","fill":"#E3E6E8","stroke":_vm.backgroundColor2 || '#E5E6E6'}}),(_vm.banner)?_c('image',{attrs:{"href":_vm.banner,"x":"182","y":"63","width":"314","height":"120","clip-path":"url(#clip_round_banner)","preserveAspectRatio":"xMidYMid slice"}}):_c('path',{attrs:{"d":"M182 67C182 64.7909 183.791 63 186 63H492C494.209 63 496 64.7909 496 67V179C496 181.209 494.209 183 492 183H186C183.791 183 182 181.209 182 179V67Z","fill":_vm.backgroundColor3 || '#F2F2F3'}}),_c('rect',{attrs:{"x":"182.25","y":"195.25","width":"313.5","height":"61.5","rx":"3.75","fill":_vm.backgroundColor3 || '#FFFFFF'}}),_c('circle',{attrs:{"cx":"201","cy":"214","r":"9","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"218","y":"210","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"192","y":"235","width":"12","height":"12","rx":"2","fill":_vm.brandColor}}),_c('rect',{attrs:{"x":"182.25","y":"195.25","width":"313.5","height":"61.5","rx":"3.75","stroke":_vm.backgroundColor2 || '#E5E6E6',"stroke-width":"0.5"}}),_c('g',{attrs:{"clip-path":"url(#clip1_941_26253)"}},[_c('rect',{attrs:{"x":"182.25","y":"269.25","width":"313.5","height":"57.5","rx":"3.75","fill":_vm.backgroundColor3 || '#FFFFFF'}}),_vm._l((_vm.quickLinks),function(i){return [_c('rect',{attrs:{"x":194 + (65.4 * (i - 1)),"y":"306","width":"41.4","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('ellipse',{attrs:{"cx":214.7 + (65.4 * (i - 1)),"cy":"291","rx":"9","ry":"9","fill":"#E3E6E8"}})]}),_c('rect',{attrs:{"x":"182.25","y":"269.25","width":"313.5","height":"57.5","rx":"3.75","stroke":_vm.backgroundColor2 || '#E5E6E6',"stroke-width":"0.5"}})],2),(_vm.quickLinks > 4)?[_c('rect',{attrs:{"x":"460","y":"310","width":"24","height":"24","rx":"12","transform":"rotate(-90 460 310)","fill":_vm.brandColor,"opacity":".5"}}),_c('path',{attrs:{"d":"M469.671 303.193C469.544 303.193 469.424 303.144 469.334 303.053C469.149 302.868 469.149 302.566 469.334 302.38L473.854 297.861L469.334 293.342C469.244 293.252 469.195 293.132 469.195 293.005C469.195 292.878 469.244 292.758 469.334 292.669C469.424 292.579 469.544 292.529 469.671 292.529C469.798 292.529 469.918 292.579 470.007 292.669L474.527 297.188C474.897 297.559 474.898 298.163 474.527 298.533L470.007 303.053C469.918 303.144 469.798 303.193 469.671 303.193Z","fill":_vm.color2,"stroke":_vm.color2}}),_c('rect',{attrs:{"x":"210","y":"286","width":"24","height":"24","rx":"12","transform":"rotate(90 210 286)","fill":_vm.brandColor,"opacity":".5"}}),_c('path',{attrs:{"d":"M200.329 292.807C200.456 292.807 200.576 292.856 200.666 292.947C200.851 293.132 200.851 293.434 200.666 293.62L196.146 298.139L200.666 302.658C200.756 302.748 200.805 302.868 200.805 302.995C200.805 303.122 200.756 303.242 200.666 303.331C200.576 303.421 200.456 303.471 200.329 303.471C200.202 303.471 200.082 303.421 199.993 303.331L195.473 298.812C195.103 298.441 195.102 297.837 195.473 297.467L199.993 292.947C200.082 292.856 200.202 292.807 200.329 292.807Z","fill":_vm.color2,"stroke":_vm.color2}})]:_vm._e(),_c('rect',{attrs:{"x":"182.25","y":"339.25","width":"313.5","height":"71.5","rx":"3.75","fill":_vm.backgroundColor3 || '#FFFFFF'}}),_c('rect',{attrs:{"x":"192","y":"349","width":"46","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"192","y":"369","width":"294","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"192","y":"381","width":"144","height":"8","rx":"2","fill":"#E3E6E8"}}),_c('rect',{attrs:{"x":"192","y":"397","width":"19","height":"4","rx":"2","fill":_vm.brandColor}}),_c('rect',{attrs:{"x":"219","y":"397","width":"19","height":"4","rx":"2","fill":_vm.brandColor}}),_c('rect',{attrs:{"x":"182.25","y":"339.25","width":"313.5","height":"71.5","rx":"3.75","stroke":_vm.backgroundColor2 || '#E5E6E6',"stroke-width":"0.5"}}),_c('rect',{attrs:{"width":"672","height":"26","transform":"translate(0 1)","fill":_vm.backgroundColor3 || _vm.brandColor}}),_c('rect',{attrs:{"x":"90","y":"10","width":"8","height":"8","rx":"2","fill":_vm.tintIcons ? _vm.color2 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"154","y":"10","width":"8","height":"8","rx":"2","fill":_vm.tintIcons ? _vm.color2 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"218","y":"10","width":"8","height":"8","rx":"2","fill":_vm.tintIcons ? _vm.color2 : '#E5E6E6'}}),_c('rect',{attrs:{"x":"102","y":"10","width":"36","height":"8","rx":"2","fill":_vm.foregroundColor1 || _vm.color2}}),_c('rect',{attrs:{"x":"166","y":"10","width":"36","height":"8","rx":"2","fill":_vm.foregroundColor1 || _vm.color2}}),_c('rect',{attrs:{"x":"230","y":"10","width":"36","height":"8","rx":"2","fill":_vm.foregroundColor1 || _vm.color2}}),_c('rect',{attrs:{"x":"278","y":"6","width":"56","height":"16","rx":"8","fill":_vm.backgroundColor3 || _vm.color2}}),_c('rect',{attrs:{"x":"282","y":"10","width":"8","height":"8","rx":"2","fill":_vm.tintIcons ? _vm.brandColor : '#E5E6E6'}}),_c('rect',{attrs:{"x":"294","y":"10","width":"36","height":"8","rx":"2","fill":_vm.brandColor}}),_c('g',{attrs:{"opacity":"0.8"}},[_c('rect',{attrs:{"x":"496","y":"8","width":"86","height":"12","rx":"6","fill":_vm.foregroundColor2 || '#FFFFFF'}})]),_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"671","height":"419","rx":"7.5","stroke":_vm.backgroundColor2 || '#E5E6E6'}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_941_26253"}},[_c('rect',{attrs:{"width":"672","height":"420","rx":"8","fill":"white"}})]),_c('clipPath',{attrs:{"id":"clip1_941_26253"}},[_c('rect',{attrs:{"width":"314","height":"58","fill":"white","transform":"translate(182 269)"}})]),_c('clipPath',{attrs:{"id":"clip_round_banner"}},[_c('rect',{attrs:{"x":"182","y":"63","width":"314","height":"120","rx":"4","fill":"white"}})])])],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WebPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__